import React from 'react';
import ServiceLayout from '../layouts/ServiceLayout';
import { Box, Typography, Grid, Paper } from '@mui/material';

const GeriatricPhysiotherapy = () => {
  const serviceData = {
    title: "Geriatric Physiotherapy",
    image: "/geriatric.png",
    description: "Our geriatric physiotherapy service is specially designed to meet the unique needs of older adults. We focus on improving mobility, balance, and overall function to help maintain independence and quality of life.",
    benefits: [
      "Improved balance and stability",
      "Enhanced mobility",
      "Greater independence",
      "Reduced fall risk",
      "Better overall function",
      "Improved quality of life"
    ],
    approach: [
      "Comprehensive geriatric assessment",
      "Balance and fall prevention programs",
      "Strength and mobility training",
      "Pain management strategies",
      "Arthritis management",
      "Home safety evaluation"
    ],
    additionalContent: (
      <Box sx={{ mt: 4 }}>
        <Typography variant="h4" gutterBottom>
          Specialized Programs
        </Typography>
        <Grid container spacing={3}>
          {[
            {
              title: "Fall Prevention",
              description: "Comprehensive assessment and training to reduce fall risks and improve confidence in movement."
            },
            {
              title: "Arthritis Management",
              description: "Specialized exercises and techniques to manage arthritis symptoms and maintain joint health."
            },
            {
              title: "Home Safety",
              description: "Assessment and recommendations for creating a safer home environment to support independence."
            }
          ].map((program, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Paper
                elevation={0}
                sx={{
                  p: 3,
                  height: '100%',
                  borderRadius: 2,
                  border: '1px solid',
                  borderColor: 'divider',
                  transition: 'transform 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-5px)',
                    boxShadow: '0 8px 24px rgba(0,150,136,0.15)'
                  }
                }}
              >
                <Typography variant="h6" gutterBottom color="primary">
                  {program.title}
                </Typography>
                <Typography variant="body2">
                  {program.description}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Box>
    )
  };

  return <ServiceLayout {...serviceData} />;
};

export default GeriatricPhysiotherapy; 